import { PersonSearch } from "@mui/icons-material";
import { IFeatures } from "../../utils/interfaces";

import { useSessionContext } from "../../contexts/SessionContext";
import { MedicalCare } from "./MedicalCare";
import { currentFeatures } from "@/configs/Settings";
import VetAttendence from "@/fluxvet/pages/vetattendence/VetAttendence";

export function useMedicalCare() {
  const { access } = useSessionContext();

  const configs: IFeatures = {
    active: access.type === "professional",
    path: "/clinicalregister",
    icon: PersonSearch,
    text: "Registro clínico",
    sideMenu: false,

    // avatarMenuText: "Prototipo",
    component: () =>
      currentFeatures.defaultApp ? <MedicalCare /> : <VetAttendence />,
  };

  return configs;
}
